  // src/App.jsx
  import './App.css';

  // 🔹 Main Components
  import Navbar from './components/Navbar';
  import TrainStrip from './components/TrainStrip';
  import Header from './components/Header';
  import About from './components/About';
  import Previous from './components/Previous';
  import Projects from './components/Projects';
  import Skills from './components/Skills';
  import ResearchManager from './components/ResearchManager';
  import Gallery from './components/Gallery';
  import LatestProjects from './components/LatestProjects';
  import ResearchPapers from './components/ResearchPapers';
  import Contact from './components/Contact';
  import InternshipPanel from './components/InternshipPanel';
  import Footer from './components/Footer';

  // ⚡ VoltBot (Floating Electrical Chat Assistant)
  import VoltBot from './components/VoltBot';

  // 🔔 Toast Notifications
  import { ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

  function App() {
    return (
      <div className="App relative">
        {/* 🔝 Sticky Navbar */}
        <Navbar />

        {/* 🚆 Train Message Strip */}
        <TrainStrip />

        {/* 🧑‍💻 Hero Section */}
        <Header />

        {/* 📚 Main Page Sections */}
        <main>
          <About />
          <Previous />
          <Projects />
          <ResearchPapers />
          <ResearchManager />
          <InternshipPanel />
          <LatestProjects />
          <Skills />
          <Gallery />
          <Contact />
        </main>

        {/* 🔻 Footer Section */}
        <Footer />

        {/* ⚡ Floating VoltBot Chat Assistant */}
        <VoltBot />

        {/* 🔔 Notification System */}
        <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      </div>
    );
  }
export default App;
